<template>
<div class="invite">
  <div class="containter mh100vh">
    <div class="tit tac">即刻加入可享受如下权益</div>
    <div class="box1">
      <div class="item df aic">
        <img src="./assets/img/si1.png" alt="">
        <div>
          <div class="t1 c_fff">特点一</div>
          <div class="t2">开启推广好友赚佣金，收益看得见</div>
        </div>
      </div>
      <div class="item df aic">
        <img src="./assets/img/si2.png" alt="">
        <div>
          <div class="t1 c_fff">特点二</div>
          <div class="t2">好友洗衣消费即享提成</div>
        </div>
      </div>
      <div class="item df aic">
        <img src="./assets/img/si3.png" alt="">
        <div>
          <div class="t1 c_fff">特点三</div>
          <div class="t2">收益可转洗衣余额，可提现</div>
        </div>
      </div>
    </div>
    <router-link :to="{ name: 'vipbuy'}" class="btn btn1 db tac">立即开通年费会员</router-link>
  </div>
</div>
</template>
<script>
import weui from 'weui.js'
export default{
  data(){
    return{
      account:{},
    }
  },
  mounted() {

  },
  methods:{
      
  }
}
</script>



// WEBPACK FOOTER //
// src/invite.vue